module.exports = __webpack_public_path__ + "img/fourth-image.96ff7645.png";